import { communityReferrals } from "../constants/communityReferralsActionTypes";

const defaultPagination = {
  total_pages: 0,
  current_page: 1,
  records_per_page: 10,
  total_records: 0,
  prev_page: null,
  next_page: null,
  prev_url: null,
  next_url: null
};

// GROWTH-8125: preloaders.<section> and errors.<section> as 03-react-dashboard.mdc asks; an error is toLoadError's object.
const defaultV2 = {
  list: { rows: [], pagination: { ...defaultPagination }, loaded: false },
  counts: null,
  // Open requests across every follow, counted once (the "All" chip); null until an unfiltered counts answer.
  allOpen: null,
  follows: null,
  preloaders: { list: false },
  errors: { list: null, follows: null }
};

const defaultState = {
  v2: defaultV2,
  loading: false,
  referralsLoading: false,
  error: null,
  query: {
    search: "",
    professionId: "all",
    sort: "created",
    order: "DESC",
    page: 1,
    perPage: 10,
    followingId: "all"
  },
  referrals: [],
  pagination: { ...defaultPagination },
  stats: {
    openRequests: 0,
    fromYourCommunities: 0,
    contributions: 0,
    peopleYouHelped: 0,
    communities: []
  }
};

export default function reducer(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case communityReferrals.SET_STATS_LOADING:
      return {
        ...state,
        loading: payload
      };

    case communityReferrals.GET_STATS_SUCCESS:
      return {
        ...state,
        stats: payload,
        error: null
      };

    case communityReferrals.GET_STATS_FAIL:
      return {
        ...state,
        error: payload
      };

    case communityReferrals.SET_QUERY:
      return {
        ...state,
        query: {
          ...state.query,
          ...payload
        }
      };

    case communityReferrals.SET_REFERRALS_LOADING:
      return {
        ...state,
        referralsLoading: payload
      };

    case communityReferrals.GET_REFERRALS_SUCCESS:
      return {
        ...state,
        referrals: payload.referrals,
        pagination: payload.pagination || { ...defaultPagination },
        error: null
      };

    case communityReferrals.GET_REFERRALS_FAIL:
      return {
        ...state,
        error: payload
      };

    // GROWTH-8125. `silent` keeps the rows on screen while a refetch runs.
    case communityReferrals.V2_LIST_REQUEST:
      return {
        ...state,
        v2: { ...state.v2, preloaders: { ...state.v2.preloaders, list: !payload.silent }, errors: { ...state.v2.errors, list: null } }
      };

    case communityReferrals.V2_LIST_SUCCESS:
      return {
        ...state,
        v2: {
          ...state.v2,
          list: { rows: payload.rows, pagination: payload.pagination, loaded: true },
          preloaders: { ...state.v2.preloaders, list: false },
          errors: { ...state.v2.errors, list: null }
        }
      };

    case communityReferrals.V2_LIST_FAIL:
      return {
        ...state,
        v2: {
          ...state.v2,
          list: { ...state.v2.list, rows: [], loaded: true },
          preloaders: { ...state.v2.preloaders, list: false },
          errors: { ...state.v2.errors, list: payload }
        }
      };

    case communityReferrals.V2_COUNTS_SUCCESS:
      return {
        ...state,
        v2: { ...state.v2, counts: payload, allOpen: action.meta?.unscoped ? payload.open : state.v2.allOpen }
      };

    case communityReferrals.V2_COUNTS_FAIL:
      return { ...state, v2: { ...state.v2, counts: null } };

    case communityReferrals.V2_FOLLOWS_SUCCESS:
      return { ...state, v2: { ...state.v2, follows: payload, errors: { ...state.v2.errors, follows: null } } };

    case communityReferrals.V2_FOLLOWS_FAIL:
      return { ...state, v2: { ...state.v2, follows: null, errors: { ...state.v2.errors, follows: payload } } };

    case communityReferrals.V2_CLEAR:
      return { ...state, v2: defaultV2 };

    default:
      return state;
  }
}
